import React from 'react';
import { Link } from 'react-router-dom';

import './Breadcrumb.scss';
import FontAwesomeIcon from '../Icon';

const Breadcrumb = ({ to, label }) => (
  <Link
    className="breadcrumb"
    to={to}
  >
    <FontAwesomeIcon
      weight="light"
      glyph="arrow-left"
    />
    {label}
  </Link>
);

export default Breadcrumb;
